<template>
    <div>
        <buttonlist @help="help" @exps="exps" ref="SetBtn"></buttonlist>
        <el-card class="box-card">
            <div style="display: flex;background: white">
                <div style="width: 50%;text-align: left;display: flex">
                    <el-date-picker
                            v-model="BeginDate"
                            value-format="yyyy-MM"
                            type="month"
                    >
                    </el-date-picker>
                    ~
                    <el-date-picker v-model="EndDate" value-format="yyyy-MM" type="month">
                    </el-date-picker>

                    <el-button
                            type="primary"
                            size="mini"
                            style="margin-left: 5px;"
                            @click="getView()"
                    >{{ $t("getapi[938]") }}
                    </el-button
                    >
                </div>
            </div>
        </el-card>
        <ul class="Boxs" ref="Box" :style="{ height: tableHeight + 'px' }">
            <li style="width: 100%; margin-top:0px">
                <div id="xpane-0">
                    <vxe-table
                            :data="dataSet"
                            v-loading="loading"
                            border                            
                            resizable
                            size="mini"
                            :row-class-name="tableRowClassName1"
                            :height="tableHeight"
                            ref="singleTable"
                    >
                        <vxe-table-column
                                show-overflow
                                field="workcenter_name"
                                :title="$t('getapi[585]')"
                                width="150"
                        />
                        <vxe-table-column
                                show-overflow
                                field="report_method_name"
                                :title="$t('getapi[3260]')"
                                width="100"
                        />
                        <vxe-table-column
                                field="actually_manhour"
                                :title="$t('getapi[7485]')"
                                align="right"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.actually_manhour | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                                field="man_cost"
                                :title="$t('getapi[7631]')"
                                align="right"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.man_cost | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                                field="man_price"
                                :title="$t('getapi[8384]')"
                                align="right"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.man_price | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                                field="charge_cost"
                                :title="$t('getapi[6047]')"
                                align="right"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.charge_cost | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                                field="charge_price"
                                :title="$t('getapi[8381]')"
                                align="right"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.charge_price | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                                field="labor_costs_price"
                                :title="$t('getapi[12502]')"
                                align="right"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.labor_costs_price | thousandth2 }}
                            </template>
                        </vxe-table-column>
                        <vxe-table-column
                                field="process_cost"
                                :title="$t('getapi[12503]')"
                                align="right"
                                width="100"
                        >
                            <template slot-scope="scope">
                                {{ scope.row.process_cost | thousandth2 }}
                            </template>
                        </vxe-table-column>
                    </vxe-table>
                </div>
            </li>
        </ul>

        <serce
                :isVisible="isVisible"
                queryData="SumRunningHourInfo"
                ref="ser"
                @getser="serclick"
        ></serce>
    </div>
</template>

<script>
    import Common from "@/components/Common";
    import Array from "@/components/Array";

    export default {
        name: "3_monthmanchargecost",
        computed: {
            tableOption() {
                return {
                    border: true,
                    height: this.$windowSize.tableHeight-240,
                    maxHeight: this.$windowSize.tableHeight-240,
                }
            },
            tableHeight(){
                return this.$windowSize.tableHeight2
            }
        },
        data() {
            return {
                totalcost: 0,
                dialogVisible: false, //时间选择弹框
                dataSet: [], // 主表数据
                isVisible: false, // 查询列表是否显示
                queryData: [], // 查询数组
                userData: [], // 用户信息
                DbTbNames: "",
                pageIndex: 1, // 当前页
                pageSize: 100, // 当前页数据量
                SelectIndexs: 1, //当前页面
                total: 0, // 数据总量
                loading: false, // 主表加载状态
                isShowEdit: false, // 是否显示编辑页面
                tableHeader: [],
                BeginDate: "",
                EndDate: "",
                scrollTop: 0,
            };
        },
        watch: {
            dataSet: function () {
                let that = this;
                that.$nextTick(function () {
                    setTimeout(() => {
                        that.$processdata.initForm(0);
                    }, 500);
                });
            },
        },
        mounted: function () {
            let that = this;
            that.userData = sessionStorage.getItem("userData");
            that.PlanTypeArray = Array.methods.getPlanType();
            that.authority();
        },
        activated() {
            let that = this
            setTimeout(() => {
                that.$refs.singleTable.bodyWrapper.addEventListener('scroll', (res) => {
                    that.scrollTop = res.target.scrollTop
                }, false)
            }, 5000);
            // 路由跳转回来滚动到离开时的位置
            this.$nextTick(() => {
                setTimeout(() => {
                    this.$refs.singleTable.bodyWrapper.scrollTop = this.scrollTop;
                }, 13)
            })
        },
        methods: {
            help(){
                this.$refs.SetBtn.showHelp(this.$options.name,this.$t("getapi[12501]"),this.$t("getapi[6633]"));
            },
            //type 1 一览权限 、2 编辑界面权限
            authority() {
                let that = this;
                if(that.$loadviewfields.isEnableHelp(this.$options.name) == 1){
                    that.$refs.SetBtn.SetOneBtnEnable('help',true);
                }
                let limits = 1;
                that.$refs.SetBtn.SetButtonEnable("export", true);
                return;
            },
            getView() {
                let that = this;
                if (that.$limits.fnIsEmpty(that.BeginDate)) {
                    that.$message.warning(that.$t("getapi[7179]")); //"请选择日期"
                    return;
                }
                if (that.$limits.fnIsEmpty(that.EndDate)) {
                    that.$message.warning(that.$t("getapi[3327]")); //"请选择日期"
                    return;
                }

                let datac = {
                    BeginDate: that.BeginDate + "-01",
                    EndDate: that.EndDate + "-01",
                    LangType: that.$processdata.getLang(),
                };
                that.loading = true;
                that.$http.urlpost(
                    "/CostCalc/MMCView/GetMonthManChargeCostView",
                    datac,
                    function (res) {
                        if (res.Success == 1) {
                            that.dataSet = res.DataContent;
                            that.totalcost = that.$processdata.explainCallbackMsg(res.Msg);
                        }
                        that.loading = false;
                    }
                );
            },
            tableRowClassName1({row, rowIndex}) {
                if (row.workcenter_name == '总计') {
                    return 'blue'
                }
            },
            // 导出
            exps() {
                let that = this;
                that.loading = true;
                if (that.$limits.fnIsEmpty(that.BeginDate)) {
                    that.$message.warning(that.$t("getapi[7179]")); //"请选择日期"
                    return;
                }
                if (that.$limits.fnIsEmpty(that.EndDate)) {
                    that.$message.warning(that.$t("getapi[3327]")); //"请选择日期"
                    return;
                }
                let datac = {
                    BeginDate: that.BeginDate + "-01",
                    EndDate: that.EndDate + "-01",
                    LangType: that.$processdata.getLang(),
                };
                that.$http.urlpost(
                    "/CostCalc/MMCView/GetMonthManChargeCostViewToExecl",
                    datac,
                    function (res) {
                        if (res.Success == 1) {
                            let hrefurl = Common.Url + res.DataContent.URL;
                            window.open(hrefurl);
                        }
                        that.loading = false;
                    }
                );
            },
            // 刷新
            reflash() {
                let that = this;
                that.getView();
            },
        },
    };
</script>

<style scoped lang="less">
    table {
        border-collapse: separate;
        border-spacing: 0px 5px;
        td {
            padding-left: 3px;
            white-space: pre;
        }
    }

    .bbl {
        margin: 0px auto 10px;
        white-space: pre;
        span {
            margin-left: 10px;
            min-width: 70px;
            text-align: left;
            line-height: 20px;
            display: inline-block;
            margin-right: 0px;
        }
    }

    /deep/ .blue {
        background: #a9e79d;
    }
</style>
